import React, { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { actionCreators as optimActionCreators } from '../../store/Optim.ts'
import { AttributeBox } from '../config/AttributeBox'
import './EditConstraints.scss'
import { act } from 'react'

export const EditConstraints = ({ prod, area, activeConfig }) => {
    const dispatch = useDispatch()
    const history = useHistory()

    // Accessing config from Redux state
    // const model = useSelector(state => state.model)
    // const config = model[activeConfig]?.config  
    const optimizer = useSelector(state => state.optimizer)
    

    // setAttLocks function with useCallback for memoization
    const setAttOptimizable = useCallback((p, writeableAtts, canOpt) => {
        writeableAtts.forEach(att => {
            dispatch(optimActionCreators.setAttOptimizeable(p.uid, att.name, canOpt, activeConfig)) 
        })
    }, [dispatch])

    // Extract default attributes from config
    // const def = config?.productDef
    // if (!def ) return null //|| !sel

    // Find the product slot based on selection
    // const prod = config.play?.find(p => p.uid === sel.uid) || {}
    // if (!prod) return null

    const atts = optimizer.config.products.find(p => p.uid === prod.uid)?.atts
    if(!atts) return null

    // Filter writable attributes
    const writeableAtts = atts.filter(att => !att.readOnly)// && att.area === area)
    // console.log('writeableAtts', writeableAtts);
    

    return (
        <>
            <div className='optimize-product'>
                <span className='all-btn' onClick={() => setAttOptimizable(prod, writeableAtts, true)} role='button' aria-label='allow all'>
                    ALLOW ALL
                </span>
                <span className='all-btn' onClick={() => setAttOptimizable(prod, writeableAtts, false)} role='button' aria-label='disallow all'>
                    NONE
                </span>
            </div>
            <div className="constraints-area">
                <div className="att-editor">
                    {writeableAtts.map(att => (
                        <AttributeBox key={att.name} prod={prod} att={att} configModel={activeConfig} allowOptimize={true} monitor_atts={[]}/>                        
                    ))}
                </div>
            </div>
        </>
    )
}










// import * as React from 'react';
// import { connect } from 'react-redux';
// import { withRouter } from 'react-router-dom';
// import { bindActionCreators } from 'redux';
// import { actionCreators as configActionCreators } from '../../store/Config.ts';
// import { AttributeBox } from '../config/AttributeBox';
// import './EditConstraints.scss';

// export class EditConstraints extends React.Component {

//     setAttLocks = (slot, writeableAtts, newVal) => {
//         writeableAtts.forEach(att => {
//             this.props.setAttLock(slot.uid, att.name, newVal, slot.play[att.name] || att.defaultValue)
//         });
//     }

//     render() {
//         let def = this.props.config.productDefs.default;
//         if (!def) return null;

//         let selection = this.props.sel;
//         if (!selection) return null;

//         let slot = this.props.config.productSlots.find(slot => slot.uid === selection.uid) || {};
//         if (!slot) return null;

//         let writeableAtts = def.atts.filter(
//             att => att.readOnly !== true && att.area == this.props.area // eslint-disable-line eqeqeq
//         );
        
        

//         return <>
//             <div className='optimize-product'>
//                 <span className='all-btn' onClick={() => this.setAttLocks(slot, writeableAtts, false)} role='button' aria-label='allow all'>allow all</span>
//                 <span className='all-btn' onClick={() => this.setAttLocks(slot, writeableAtts, true)}  role='button' aria-label='disallow all'>disallow all</span>
//             </div>
//             <div className="constraints-area">
//                 <div className="att-editor">
//                     {writeableAtts.map(att => <AttributeBox key={att.name} prod={slot} att={att} allowOptimize={true} />)}
//                 </div>
//             </div>
//         </>;
//     }
// }

// EditConstraints = withRouter(
//     connect(
//         state => state.study,
//         dispatch => bindActionCreators(configActionCreators, dispatch)
//     )(EditConstraints)
// );
